exports.components = {
  "component---src-components-project-tsx": () => import("./../../../src/components/Project.tsx" /* webpackChunkName: "component---src-components-project-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-bio-tsx": () => import("./../../../src/pages/bio.tsx" /* webpackChunkName: "component---src-pages-bio-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-progetti-tsx": () => import("./../../../src/pages/progetti.tsx" /* webpackChunkName: "component---src-pages-progetti-tsx" */)
}

